// منبع :
// https://www.digitalocean.com/community/tutorials/vuejs-vue-chart-js
// https://www.chartjs.org/docs/latest/

export const planetChartData = {
    type: "bar",
    data: {
        labels: ["بودجه", "هزینه", "درآمد"],
        datasets: [{
            label: "درآمد",
            data: [800, 500, 600],
            backgroundColor: [
                'rgba(255, 205, 86, 0.2)',
                'rgba(75, 192, 192, 0.2)',
                'rgba(153, 102, 255, 0.2)',
            ],
            borderColor: [
                'rgb(255, 205, 86)',
                'rgb(75, 192, 192)',
                'rgb(153, 102, 255)',
            ],
            borderWidth: 1
        }, ]
    },
    options: {
        responsive: false,
        maintainAspectRatio: true,
        showScale: false,

        lineTension: 1,
        scales: {
            yAxes: [{
                ticks: {
                    beginAtZero: true,
                    padding: 25,
                    fontFamily: "VazirFD",
                }
            }],
            xAxes: [{
                ticks: {
                    beginAtZero: true,
                    padding: 15,
                    fontFamily: "VazirFD",
                }
            }],

        },
        legend: {
            display: false,
            labels: {
                fontFamily: 'VazirFD',
            }
        }
    }
};

export default planetChartData;


// WEBPACK FOOTER //
// ./src/pages/AdminPanel/Components/Dashboard/ChartComponents/right-chart-data.js